import { ResponseError } from './ResponseError';
import { AAResponseMapper } from './AAResponseMapper';
export { ResponseError, AAResponseMapper };
export var ConsentAction;
(function (ConsentAction) {
    ConsentAction["ACCEPT"] = "ACCEPT";
    ConsentAction["DENY"] = "DENY";
})(ConsentAction || (ConsentAction = {}));
//# sourceMappingURL=index.js.map